import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "Urdu",
  code: "ur",
  dir: "rtl",
  messages: {
    alert: {
      close: "\u0628\u0646\u062F \u06A9\u0631\u06CC\u06BA"
    },
    authForm: {
      hidePassword: "\u067E\u0627\u0633 \u0648\u0631\u0688 \u0686\u06BE\u067E\u0627\u0626\u06CC\u06BA",
      showPassword: "\u067E\u0627\u0633 \u0648\u0631\u0688 \u062F\u06A9\u06BE\u0627\u0626\u06CC\u06BA",
      submit: "\u062C\u0627\u0631\u06CC \u0631\u06A9\u06BE\u06CC\u06BA"
    },
    banner: {
      close: "\u0628\u0646\u062F \u06A9\u0631\u06CC\u06BA"
    },
    calendar: {
      nextMonth: "\u0627\u06AF\u0644\u0627 \u0645\u06C1\u06CC\u0646\u06C1",
      nextYear: "\u0627\u06AF\u0644\u0627 \u0633\u0627\u0644",
      prevMonth: "\u067E\u0686\u06BE\u0644\u0627 \u0645\u06C1\u06CC\u0646\u06C1",
      prevYear: "\u067E\u0686\u06BE\u0644\u0627 \u0633\u0627\u0644"
    },
    carousel: {
      dots: "\u062F\u06A9\u06BE\u0627\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0633\u0644\u0627\u0626\u06CC\u0688 \u0645\u0646\u062A\u062E\u0628 \u06A9\u0631\u06CC\u06BA",
      goto: "\u0633\u0644\u0627\u0626\u06CC\u0688 {slide} \u067E\u0631 \u062C\u0627\u0626\u06CC\u06BA",
      next: "\u0627\u06AF\u0644\u0627",
      prev: "\u067E\u0686\u06BE\u0644\u0627"
    },
    chatPrompt: {
      placeholder: "\u06CC\u06C1\u0627\u06BA \u0627\u067E\u0646\u0627 \u067E\u06CC\u063A\u0627\u0645 \u0644\u06A9\u06BE\u06CC\u06BA"
    },
    chatPromptSubmit: {
      label: "\u067E\u06CC\u063A\u0627\u0645 \u0628\u06BE\u06CC\u062C\u06CC\u06BA"
    },
    colorMode: {
      dark: "\u062A\u0627\u0631\u06CC\u06A9",
      light: "\u0631\u0648\u0634\u0646",
      switchToDark: "\u062A\u0627\u0631\u06CC\u06A9 \u0645\u0648\u0688 \u0645\u06CC\u06BA \u062A\u0628\u062F\u06CC\u0644 \u06A9\u0631\u06CC\u06BA",
      switchToLight: "\u0631\u0648\u0634\u0646 \u0645\u0648\u0688 \u0645\u06CC\u06BA \u062A\u0628\u062F\u06CC\u0644 \u06A9\u0631\u06CC\u06BA",
      system: "\u0633\u0633\u0679\u0645"
    },
    commandPalette: {
      back: "\u0648\u0627\u067E\u0633",
      close: "\u0628\u0646\u062F \u06A9\u0631\u06CC\u06BA",
      noData: "\u06A9\u0648\u0626\u06CC \u0688\u06CC\u0679\u0627 \u0646\u06C1\u06CC\u06BA",
      noMatch: "\u06A9\u0648\u0626\u06CC \u0645\u0644\u062A\u0627 \u062C\u0644\u062A\u0627 \u0688\u06CC\u0679\u0627 \u0646\u06C1\u06CC\u06BA \u0645\u0644\u0627",
      placeholder: "\u06A9\u0645\u0627\u0646\u0688 \u0679\u0627\u0626\u067E \u06A9\u0631\u06CC\u06BA \u06CC\u0627 \u062A\u0644\u0627\u0634 \u06A9\u0631\u06CC\u06BA..."
    },
    contentSearch: {
      links: "\u0644\u0646\u06A9\u0633",
      theme: "\u062A\u06BE\u06CC\u0645"
    },
    contentSearchButton: {
      label: "\u062A\u0644\u0627\u0634 \u06A9\u0631\u06CC\u06BA..."
    },
    contentToc: {
      title: "\u0627\u0633 \u0635\u0641\u062D\u06D2 \u067E\u0631"
    },
    dashboardSearch: {
      theme: "\u062A\u06BE\u06CC\u0645"
    },
    dashboardSearchButton: {
      label: "\u062A\u0644\u0627\u0634 \u06A9\u0631\u06CC\u06BA..."
    },
    dashboardSidebarCollapse: {
      collapse: "\u0633\u0627\u0626\u06CC\u0688 \u0628\u0627\u0631 \u06A9\u0648 \u0633\u06A9\u06CC\u0691\u06CC\u06BA",
      expand: "\u0633\u0627\u0626\u06CC\u0688 \u0628\u0627\u0631 \u06A9\u0648 \u067E\u06BE\u06CC\u0644\u0627\u0626\u06CC\u06BA"
    },
    dashboardSidebarToggle: {
      close: "\u0633\u0627\u0626\u06CC\u0688 \u0628\u0627\u0631 \u0628\u0646\u062F \u06A9\u0631\u06CC\u06BA",
      open: "\u0633\u0627\u0626\u06CC\u0688 \u0628\u0627\u0631 \u06A9\u06BE\u0648\u0644\u06CC\u06BA"
    },
    error: {
      clear: "\u06C1\u0648\u0645 \u067E\u06CC\u062C \u067E\u0631 \u0648\u0627\u067E\u0633 \u062C\u0627\u0626\u06CC\u06BA"
    },
    fileUpload: {
      removeFile: "{filename} \u06C1\u0679\u0627\u0626\u06CC\u06BA"
    },
    header: {
      close: "\u0645\u06CC\u0646\u0648 \u0628\u0646\u062F \u06A9\u0631\u06CC\u06BA",
      open: "\u0645\u06CC\u0646\u0648 \u06A9\u06BE\u0648\u0644\u06CC\u06BA"
    },
    inputMenu: {
      create: '"{label}" \u0628\u0646\u0627\u0626\u06CC\u06BA',
      noData: "\u06A9\u0648\u0626\u06CC \u0688\u06CC\u0679\u0627 \u0646\u06C1\u06CC\u06BA",
      noMatch: "\u06A9\u0648\u0626\u06CC \u0645\u0644\u062A\u0627 \u062C\u0644\u062A\u0627 \u0688\u06CC\u0679\u0627 \u0646\u06C1\u06CC\u06BA \u0645\u0644\u0627"
    },
    inputNumber: {
      decrement: "\u06A9\u0645\u06CC",
      increment: "\u0627\u0636\u0627\u0641\u06C1"
    },
    modal: {
      close: "\u0628\u0646\u062F \u06A9\u0631\u06CC\u06BA"
    },
    pricingTable: {
      caption: "\u0642\u06CC\u0645\u062A \u067E\u0644\u0646\u0632 \u06A9\u06CC \u0645\u0642\u0627\u06CC\u0633\u06C1"
    },
    prose: {
      codeCollapse: {
        closeText: "\u0633\u06A9\u06CC\u0691\u06CC\u06BA",
        name: "\u06A9\u0648\u0688",
        openText: "\u067E\u06BE\u06CC\u0644\u0627\u0626\u06CC\u06BA"
      },
      collapsible: {
        closeText: "\u0686\u06BE\u067E\u0627\u0626\u06CC\u06BA",
        name: "\u062E\u0635\u0648\u0635\u06CC\u0627\u062A",
        openText: "\u062F\u06A9\u06BE\u0627\u0626\u06CC\u06BA"
      },
      pre: {
        copy: "\u06A9\u0648\u0688 \u06A9\u0627\u067E\u06CC \u06A9\u0631\u06CC\u06BA"
      }
    },
    selectMenu: {
      create: '"{label}" \u0628\u0646\u0627\u0626\u06CC\u06BA',
      noData: "\u06A9\u0648\u0626\u06CC \u0688\u06CC\u0679\u0627 \u0646\u06C1\u06CC\u06BA",
      noMatch: "\u06A9\u0648\u0626\u06CC \u0645\u0644\u062A\u0627 \u062C\u0644\u062A\u0627 \u0688\u06CC\u0679\u0627 \u0646\u06C1\u06CC\u06BA \u0645\u0644\u0627",
      search: "\u062A\u0644\u0627\u0634 \u06A9\u0631\u06CC\u06BA..."
    },
    slideover: {
      close: "\u0628\u0646\u062F \u06A9\u0631\u06CC\u06BA"
    },
    table: {
      noData: "\u06A9\u0648\u0626\u06CC \u0688\u06CC\u0679\u0627 \u0646\u06C1\u06CC\u06BA"
    },
    toast: {
      close: "\u0628\u0646\u062F \u06A9\u0631\u06CC\u06BA"
    }
  }
});
